import { c as _c } from "react/compiler-runtime";
import { Tooltip } from "react-tooltip";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import { ApiDropRater } from "@/generated/models/ApiDropRater";
import { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import Link from "next/link";
interface WaveWinnersDropHeaderVoterProps {
  readonly voter: ApiDropRater;
  readonly winner: ApiWaveDecisionWinner;
  readonly index: number;
}
export default function WaveWinnersDropHeaderVoter(t0) {
  const $ = _c(23);
  const {
    voter,
    winner,
    index
  } = t0;
  const t1 = winner.drop.top_raters.length - index;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      zIndex: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `winner-voter-${voter.profile.id}`;
  const t4 = `/${voter.profile.handle}`;
  let t5;
  if ($[2] !== voter.profile.handle || $[3] !== voter.profile.pfp) {
    t5 = voter.profile.pfp ? <img src={getScaledImageUri(voter.profile.pfp, ImageScale.W_AUTO_H_50)} alt={`${voter.profile.handle}'s Profile`} className="tw-w-6 tw-h-6 tw-rounded-md tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800 tw-object-contain" /> : <div className="tw-w-6 tw-h-6 tw-rounded-lg tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800" />;
    $[2] = voter.profile.handle;
    $[3] = voter.profile.pfp;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t4 || $[6] !== t5) {
    t6 = <Link href={t4}>{t5}</Link>;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t6) {
    t7 = <div className="tw-relative tw-transition-transform hover:tw-scale-110 hover:tw-z-10" style={t2} data-tooltip-id={t3}>{t6}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = `winner-voter-${voter.profile.id}`;
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    };
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = voter.profile.handle;
  let t11;
  if ($[13] !== voter.rating) {
    t11 = formatNumberWithCommas(voter.rating);
    $[13] = voter.rating;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t11 || $[16] !== t8 || $[17] !== voter.profile.handle || $[18] !== winner.drop.wave.voting_credit_type) {
    t12 = <Tooltip id={t8} style={t9}>{t10} • {t11}{" "}{winner.drop.wave.voting_credit_type}</Tooltip>;
    $[15] = t11;
    $[16] = t8;
    $[17] = voter.profile.handle;
    $[18] = winner.drop.wave.voting_credit_type;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t12 || $[21] !== t7) {
    t13 = <>{t7}{t12}</>;
    $[20] = t12;
    $[21] = t7;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  return t13;
}